import Vue from 'vue';
import VueAnalytics from 'vue-analytics';
import Router from 'vue-router';
import 'autotrack/lib/plugins/outbound-link-tracker';
import Home from '@/components/pages/Home';
import Workflow from '@/components/pages/Workflow';
import Projects from '@/components/pages/Projects';
import Contact from '@/components/pages/Contact';
import About from '@/components/pages/About';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/about',
      name: 'About',
      component: About,
    },
    {
      path: '/workflow',
      name: 'Workflow',
      component: Workflow,
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects,
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
    },
  ],
});

Vue.use(VueAnalytics, {
  id: 'UA-xxxxxxxx-1',
  router,
  beforeFirstHit() {
    Vue.$ga.require('outboundLinkTracker');
  },
});

export default router;
